<template>
  <div class="publish-homework">
    <el-tabs v-model="tabName" type="border-card">
      <el-tab-pane name="列表" label="问卷列表">
        <surveyFormsTable :questionnaireTypeList="questionnaireTypeList"
          :getSurveyFormsListResult="getSurveyFormsListResult" :surveyFormsList="surveyFormsList" :total="total"
          @currentSurveyFormsList="currentSurveyFormsList"
          @currentSurveyFormsListPageSize="currentSurveyFormsListPageSize" @search="surveyFormsListSearch"
          @createByChange="createByChange" />
      </el-tab-pane>
      <el-tab-pane name="模板" label="模板列表">
        <templateTable :questionnaireTypeList="questionnaireTypeList" :templateTypeList="templateTypeList"
          :total="templateTotal" :questionTypeList="questionTypeList" @currentTemplateTable="currentTemplateTable"
          @currentTemplateTablePageSize="currentTemplateTablePageSize"
          @questionnaireTypeChange="questionnaireTypeChange" />
      </el-tab-pane>
      <el-tab-pane name="创建" label="创建" v-if="hasPermi('sc:survey:add')">
        <publishSurveyForms :questionnaireTypeList="questionnaireTypeList" :templateTypeList="templateTypeList"
          :questionTypeList="questionTypeList" :gradeSelectList="gradeSelectList" @addSurveyForms="addSurveyForms"
          @questionnaireTypeChange="questionnaireTypeChange" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import publishSurveyForms from "./components/publish-survey-forms/publishSurveyForms.vue";
import surveyFormsTable from "./components/survey-forms-table/surveyFormsTable.vue";
import templateTable from "./components/template-table/templateTable.vue";
export default {
  components: {
    publishSurveyForms,
    surveyFormsTable,
    templateTable
  },
  data() {
    return {
      pageSize: 10,
      pageNum: 1,
      total: 0,
      templateTotal: 0,
      templatePage: {
        pageSize: 10,
        pageNum: 1,
      },
      surveyFormsList: [],
      getSurveyFormsListResult: "nullData",
      tabName: "列表",
      questionTypeList: [],
      gradeSelectList: [],
      templateTypeList: [], // 模版列表
      questionnaireTypeList: [], // 模版分类
      questionnaireType: '', // 模版分类
      formsName: '',
      createBy: '',
    };
  },
  created() {
    this.selectSchoolAndGradeAndClassListPC();
    this.getSurveyFormsList();
    this.getDataType();
    this.queryTemplateType();
    this.getQuestionnaireType();
  },
  provide() {
    return {
      refresh: this.getSurveyFormsList,
    };
  },
  methods: {
    // 封装权限判断函数
    hasPermi(permission) {
      const permissions = window.localStorage.getItem('menuPermissions')

      if (!permissions) return false
      try {
        // 正确做法：用 split(',') 转成数组
        const permList = permissions.split(',').map(item => item.trim())
        
        return Array.isArray(permList) && permList.includes(permission)
      } catch (e) {
        console.error('解析权限列表失败:', e)
        return false
      }
    },
    createByChange(e) {
      this.createBy = e;
      this.getSurveyFormsList();
    },
    surveyFormsListSearch(e) {
      this.formsName = e;
      this.getSurveyFormsList();
    },
    // 模版分类选择
    questionnaireTypeChange(e) {
      this.questionnaireType = e;
      this.queryTemplateType();
    },
    // 查询模版分类字典
    getQuestionnaireType() {
      this.get(`${this.$url.getDictType}/sc_questionnaire_type`).then((res) => {
        this.questionnaireTypeList = res.data;
      });
    },
    currentTemplateTable(e) {
      this.templatePage.pageNum = e;
      this.queryTemplateType();
    },
    currentTemplateTablePageSize(e) {
      this.templatePage.pageSize = e;
      this.queryTemplateType();
    },
    // 查询模版
    queryTemplateType() {
      this.get(this.$url.queryTemplateType, {
        pageNum: this.templatePage.pageNum,
        pageSize: this.templatePage.pageSize,
        templateType: this.questionnaireType
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          this.templateTypeList = res.rows;
          this.templateTotal = res.total;
        })
    },
    addSurveyForms() {
      this.tabName = "列表";
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.get(this.$url.getgradeList, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          // console.log("班级列表==>", res);
          this.gradeSelectList = res.data;
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error("获取班级列表失败");
        });
    },
    getDataType() {
      this.get(this.$url.getDictType + "/sc_question_type").then((res) => {
        // console.log("调查统计表问题类型:", res);
        this.questionTypeList = res.data;
      });
    },
    publishHomework() {
      this.tabName = "列表";
    },
    currentSurveyFormsList(e) {
      this.pageNum = e;
      this.getSurveyFormsList();
    },
    currentSurveyFormsListPageSize(e) {
      this.pageSize = e;
      this.getSurveyFormsList();
    },
    getSurveyFormsList() {
      this.getSurveyFormsListResult = "loading";
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        schoolId: this.user.schoolId,
        formName: this.formsName,
        // startTime: 2023 - 02 - 03,
        // endTime: 2024 - 01 - 08,
        // gradeId: 110,
        // classId: 673,
      };
      if (this.createBy != "") {
        data.createBy = this.createBy;
      } else {
        if (data.createBy) {
          delete data.createBy;
        }
      };
      this.get(this.$url.getSurveyFormsList, data)
        .then((res) => {
          // console.log("获取问卷列表==>", res);
          if (res.code != 200) {
            this.getSurveyFormsListResult = "error";
            return this.$message.error(res.msg);
          }

          this.surveyFormsList = res.rows;
          this.total = res.total;
          this.surveyFormsList.length == 0
            ? (this.getSurveyFormsListResult = "nullData")
            : (this.getSurveyFormsListResult = "success");
          // console.log(this.getSurveyFormsListResult);
        })
        .catch((err) => {
          // console.log(err);
          // console.log(this.getSurveyFormsListResult);
          this.total == 0
            ? (this.getSurveyFormsListResult = "nullData")
            : (this.getSurveyFormsListResult = "success");
          // this.getSurveyFormsListResult = "error";
          // this.$message.error("获取作业列表失败");
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./surveyTable.scss";
</style>
